var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "designer-add-to-cart" }, [
    _c(
      "div",
      {
        staticClass: "order-checkout",
        class: _vm.producOutOfStock ? "product-out-of-stock" : "",
      },
      [
        _c("div", { staticClass: "price-group" }, [
          _c(
            "div",
            {
              staticClass: "price",
              staticStyle: { "vertical-align": "sub" },
              attrs: {
                itemprop: "offers",
                itemscope: "itemscope",
                itemtype: "http://schema.org/Offer",
              },
            },
            [
              _vm.getSign.saleprice !== "0"
                ? _c("span", { staticClass: "price-group-real-price" }, [
                    _vm._v(_vm._s(_vm.getSign.price) + "\n          "),
                    _vm.languageStrings.currency_symbol
                      ? _c("span", {
                          domProps: {
                            innerHTML: _vm._s(
                              _vm.languageStrings.currency_symbol
                            ),
                          },
                        })
                      : _vm._e(),
                  ])
                : _vm._e(),
              _c("span", { attrs: { itemprop: "price" } }, [
                _vm._v(_vm._s(_vm.aggregatedPrice) + "\n          "),
                _vm.languageStrings.currency_symbol
                  ? _c("span", {
                      domProps: {
                        innerHTML: _vm._s(_vm.languageStrings.currency_symbol),
                      },
                    })
                  : _vm._e(),
              ]),
            ]
          ),
          _vm._v(" "),
          _c("div", { staticClass: "price-vat" }, [
            _c("span", { attrs: { itemprop: "price" } }, [
              _vm._v(_vm._s(_vm.calculateVat(_vm.aggregatedPrice))),
            ]),
            _vm._v(" "),
            _vm.languageStrings.ex_vat
              ? _c("span", [
                  _vm._v("\n          " + _vm._s(_vm.languageStrings.ex_vat)),
                ])
              : _vm._e(),
          ]),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "add-to-cart-group" }, [
          _c(
            "button",
            {
              staticClass: "button is-primary",
              attrs: {
                type: "button",
                disabled: _vm.addedToCart || _vm.producOutOfStock,
              },
              on: { click: _vm.addCurrentToCart },
            },
            [
              !_vm.producOutOfStock
                ? _c("span", [_vm._v(_vm._s(_vm.languageStrings.add_to_cart))])
                : _vm._e(),
              _vm._v(" "),
              _vm.producOutOfStock
                ? _c("span", [_vm._v(_vm._s(_vm.languageStrings.out_of_stock))])
                : _vm._e(),
            ]
          ),
        ]),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }